import { updatePrivateMessageHideToEveryone } from '@moal/api'
import { PRODUCT_CODE } from '../../../../utils/ENV'
import { toastSuccess } from '../../../../utils/toast'
import ConfirmButton from '../../../Buttons/ConfirmButton'
import Tooltip from '../../../Utilities/Tooltip'

const DeletePrivateMessages = () => {
  const handleUpdatingMessages = async () => {
    const response = await updatePrivateMessageHideToEveryone({
      token: localStorage.getItem('authToken'),
      itemNumber: PRODUCT_CODE
    })
    if (response && response.status === 200) {
      toastSuccess(
        `${response.data.modified} "To Everyone" messages succesfully updated.`
      )
    }
  }

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <h2 className="mr-3">Hide all "To Everyone" messages</h2>
        <Tooltip>
          This doesn't delete any messages but updates the status of all
          messages "to everyone" to false so they no longer show for users.
        </Tooltip>
      </div>
      <ConfirmButton
        label={'Submit'}
        callback={() => handleUpdatingMessages(true)}
      />
    </div>
  )
}

export default DeletePrivateMessages
